// basiq-success.page.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-basiq-success',
  templateUrl: './basiq-success.page.html',
  styleUrls: ['./basiq-success.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    RouterLink
  ]
})
export class BasiqSuccessPage {
  constructor() {}

  ngAfterViewInit() {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }
}